import { render, staticRenderFns } from "./TitleHeader.vue?vue&type=template&id=978f9506&scoped=true&"
import script from "./TitleHeader.vue?vue&type=script&lang=ts&"
export * from "./TitleHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TitleHeader.vue?vue&type=style&index=0&id=978f9506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978f9506",
  null
  
)

export default component.exports